<template>
  <div>
    <div class="row my-3">
      <div class="col-9">
        <div class="total-taxable-income">
          Click on 'Add Dependent' to add dependents and to be eligible for some
          of the deduction options
        </div>
      </div>
      <div class="col-3">
        <div class="add-new-investment" @click="openAddDependents()">
          <img class="img-icon" src="@/assets/circle-cross.svg" alt />
          Add Dependents
        </div>
      </div>
    </div>
    <data-table
      :columns="tableColumns"
      :tableData="dependentsList"
      :checkbox="false"
      :withForm="false"
      :showhistory="false"
      :showedit="false"
      @editStart="initEditStart"
      @delete="deleteItem"
    >
      <template v-slot:rowcontent="slotprops">
        <p v-if="slotprops.value.column.key === 'name'">
          {{ slotprops.value.record[slotprops.value.column.key] }}
        </p>
        <p v-if="slotprops.value.column.key === 'age'">
          {{ slotprops.value.record[slotprops.value.column.key] }}
        </p>
        <p v-if="slotprops.value.column.key === 'relationship'">
          {{ slotprops.value.record[slotprops.value.column.key] }}
        </p>
        <p v-if="slotprops.value.column.key === 'maritalstatus'">
          {{ slotprops.value.record[slotprops.value.column.key] }}
        </p>
      </template>
    </data-table>

    <footer>
      <popup-bottom-container>
        <template slot="end">
          <btn-grp class="form-button">
            <btn text="Back" type="secondary" @click="goBack" />
          </btn-grp>
        </template>
      </popup-bottom-container>

      <pop-up-message
        v-if="showPopup"
        :message="popupMessage"
        :popupType="popupType"
        :popupHeaderMessage="'Confirm Delete'"
        :closable="false"
      >
        <template v-slot:bottomContent>
          <btn-grp>
            <popup-btn text="Cancel" type="secondary" @click="cancelEvent" />
            <popup-btn text="Delete" type="primary" @click="deleteEvent" />
          </btn-grp>
        </template>
      </pop-up-message>
    </footer>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { eventBus } from "@/main";

export default {
  name: "dependentsPopup",
  data() {
    return {
      tableColumns: [
        {
          label: "Name",
          key: "name",
        },
        {
          label: "Age",
          key: "age",
        },
        {
          label: "Relationship",
          key: "relationship",
        },
        {
          label: "Marital Status",
          key: "maritalstatus",
        },
      ],
      dependentsList: [],
      instance: {
        employee_id: "",
        it_plan_id: "",
      },
      showPopup: false,
      popupType: "Warning",
      popupMessage: "Are you sure you want to delete ?",
      selectedItem: "",
      dependentData: null,
    };
  },
  activated() {
    this.fetchemp();
  },
  mounted() {
    this.fetchemp();
  },
  computed: {
    ...mapGetters({
      getleid: "onboard/legal_entities/legal_entity_ID",
    }),

    le_id() {
      if (this.$route.params.entity_index)
        return this.getleid(this.$route.params.entity_index);
      else return this.getleid(0);
    },
  },
  methods: {
    ...mapActions({
      act_fetch: "onboard/employees/fetchAll",
      fetchLocations: "onboard/locations/fetchAll",
      act_get_dependents: "dashboard/payroll/incometax/getDependentList",
      act_get_active_it_plan: "dashboard/payroll/incometax/getActiveList",
      act_delete: "dashboard/payroll/incometax/deleteDependents",
    }),

    /* server call to get Employees for current Legal Entity */
    async fetchemp() {
      try {
        let empId = this.$route.query.id;
        this.instance.employee_id = empId;
        let data = await this.act_get_active_it_plan(empId);
        this.instance.it_plan_id = data.data.payload.id;
        let res = await this.act_get_dependents({
          it_plan_id: this.instance.it_plan_id,
          employee_id: empId,
        });
        if (res.data.status) {
          this.dependentsList = res.data.payload;
        }
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },

    openAddDependents() {
      this.$emit("openNewDependents");
    },

    async deleteItem(rec) {
      try {
        this.showPopup = true;
        this.selectedItem = rec;
        //console.log("Dependent", this.selectedItem);
        //let res = await this.act_delete(rec.id);
        // if (res.status == 200) {
        //   this.showPopup = true;
        // }
      } catch (err) {
        //console.log("error msg", err.message);
        this.toast = true;
        this.errmsg = err.message;
      }
    },

    /* server to delete dependent */
    async deleteEvent() {
      try {
        let res = await this.act_delete(this.selectedItem.id);
        if (res.status == 200) {
          this.showPopup = false;
          this.fetchemp();
          //this.selectedItem = null;
        }
      } catch (err) {
        this.toast = true;
        this.errmsg = err.message;
      }
    },

    /* function to hide the pop-up */
    cancelEvent() {
      this.showPopup = false;
    },

    // Add here code for cancel button to hide popup By Bhushan
    goBack() {
      this.$emit("back");
    },

    /* server to edit dependent */
    initEditStart(rec) {
      this.dependentData = rec;
      eventBus.$emit("editDependent", this.dependentData);
      this.$emit("openNewDependents");
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/scss/components/margins.scss"; //margins
@import "@/scss/_variables.scss";

.add-new-investment {
  text-align: right;
  font-size: 14px;
  font-weight: 600;
  color: #34c0be;
  cursor: pointer;
  transform: translate(0px, 0px);
}

.total-taxable-income {
  font-size: 15px;
  font-weight: normal;
  color: #444444;
}

.img-icon {
  transform: translate(-1px, 5px);
}
</style>
